module.exports = __webpack_public_path__ + "img/dropdown-arrow--black.f4f442bc.svg";